<ng-content select="core-ui-dropdown-menu-item"></ng-content>

<core-ui-button-base
  #trigger
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  iconOnly
  variant="tertiary"
  [size]="triggerSize"
  [iconColor]="triggerIconColor"
  [iconSize]="triggerIconSize"
  [iconDirection]="triggerIconDirection"
  [icon]="triggerIcon"
  btnClass="core-ui-dropdown-menu__trigger"
  [active]="isOpen"
  [ariaLabel]="triggerAriaLabel"
  ariaHasPopup="menu"
  [ariaExpanded]="isOpen"
  [disabled]="isTriggerDisabled"
  (clicked)="toggle()"
></core-ui-button-base>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayPush]="push"
  [cdkConnectedOverlayViewportMargin]="viewportMargin"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayHasBackdrop]="false"
  (overlayOutsideClick)="close(true)"
  (detach)="onOverlayDetach()"
  (positionChange)="onPositionChange($event)"
>
  <core-ui-context-menu
    [style.--core-context-menu-width]="menuWidth"
    [size]="size"
    [appearance]="appearance"
    [variant]="variant"
    [openDirection]="menuPosition"
    [ariaLabel]="ariaLabel"
    [items]="items"
    (itemSelected)="selectAction($event)"
    (dismissed)="close(true)"
  ></core-ui-context-menu>
</ng-template>
